import { AtlasH1 } from '@justomx/atlas-components'
import { motion } from 'framer-motion'
import { LoaderSvg } from 'components/atoms/Loader.atom'

interface CircularProgressProps {
  value: number
  text?: string
  size?: number
  loading?: boolean
}

export const CircularProgressMolecule = (props: CircularProgressProps) => {
  const { value, text, size = 100, loading = false } = props

  const strokeWidth = 6
  const padding = 14
  const radius = (size - padding * 2 - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (value / 100) * circumference

  return (
    <div
      style={{
        width: size,
        height: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: '#292929',
        borderRadius: '50%'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ position: 'absolute' }}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#292929"
          strokeWidth={strokeWidth}
        />
        {!loading && (
          <motion.circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="#62E47E"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            initial={{ strokeDashoffset: circumference }}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        )}
      </svg>
      <span
        style={{
          position: 'absolute',
          color: 'white',
          fontSize: '20px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}
      >
        {loading ? <LoaderSvg></LoaderSvg> : <AtlasH1>{text}</AtlasH1>}
      </span>
    </div>
  )
}
